import "./Insights.module.css";
import MainNavigation from "@/reusable_sections/Header";
import TechPerspectives from "./sections/TechPerspectives";
import InnovationBriefing from "./sections/InnovationBriefing";
import Footer from "@/reusable_sections/Footer";
export default function InsightsPage() {
  return <div>
      <MainNavigation />
      <TechPerspectives />
      <InnovationBriefing />
      <Footer />
    </div>;
}